import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import {Button, defaultExporter} from 'react-admin';
import DownloadIcon from '@material-ui/icons/GetApp';

/**
 * Export button for a list whose table filters and sorts in the browser.
 *
 * React-Admin's ExportButton refetches through the data provider, so the file
 * follows React-Admin's own filters and never the table's column filters or
 * header sort. This button writes the rows the table currently holds instead:
 * every page, in on-screen order, exactly the on-screen membership, with no
 * second round trip. Same CSV writer and file name as the default exporter.
 *
 * @param getRows   returns the table's current rows (see DataTable onRowsChange)
 * @param resource  names the file, e.g. ClientPallet.csv
 * @param exporter  CSV writer; React-Admin's defaultExporter unless overridden
 */
const ExportRowsButton = ({getRows, resource, disabled = false, label = 'ra.action.export', exporter = defaultExporter}) => {

    const handleClick = useCallback(() => {
        const rows = getRows();
        if (!rows || rows.length === 0) {
            return;
        }
        exporter(rows, undefined, undefined, resource);
    }, [getRows, exporter, resource]);

    return (
        <Button onClick={handleClick} label={label} disabled={disabled}>
            <DownloadIcon/>
        </Button>
    );
};

ExportRowsButton.propTypes = {
    getRows: PropTypes.func.isRequired,
    resource: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    exporter: PropTypes.func
};

export default ExportRowsButton;
